import React from 'react';
import {Link} from 'react-router-dom';
import {Flex} from '@components';
import {Form, Input, Checkbox, Row, Col, Upload, Button,message} from 'antd';
import {createUuid, getLoginUser} from '@utils/NHCore';
import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "@utils/NHFetch";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import NHUpload from '@components/common/NHUpload'
const {TextArea} = Input;
const basicUrl = "/zzbd";

const shztList = {
    '-1':'审核不通过',
    '0':'未审核',
    '1':'审核通过',
    '2':'已办理',
    '9':'驳回'
}
export default class View extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nextUrl:this.props.nextUrl,
            search:this.props.search,

        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps (nextProps) {
    }

    render() {
        const { data } = this.props;
        let zsqk = data['sfzs'];

        return (
            <div>
                <TitleTop title="登记信息" extra={false}/>
                <div className="p-sw">
                    <div className="form_item" style={{width: '100%'}}>
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>住宿情况&nbsp;: </span></Col>
                            <Col span={20}><span>{zsqk ? (zsqk == '1' ? '住宿' : '走读') : ''}</span></Col>
                        </Row>
                        {
                        zsqk == '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>家长姓名&nbsp;: </span></Col>
                            <Col span={20}><span>{data['jzxm'] ? data['jzxm'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk == '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>家长电话&nbsp;: </span></Col>
                            <Col span={20}><span>{data['jzdh'] ? data['jzdh'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk == '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>居住地详细地址&nbsp;: </span></Col>
                            <Col span={20}><span>{data['jzdxxdz'] ? data['jzdxxdz'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk == '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>走读理由&nbsp;: </span></Col>
                            <Col span={20}><span>{data['sqzdly'] ? data['sqzdly'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk == '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>附件&nbsp;: </span></Col>
                            <Col span={20}><span>{
                                
                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['fjid'] ? data['fjid'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                    </div>
                </div>
                
                <div className="text-center mt-50">
                    <Button type="primary" onClick={()=>{this.props.getData()}}>
                        修改
                    </Button>
                    <NextButton nextUrl={this.state.nextUrl}  search={this.state.search}/>
                </div>
            </div>
        );
    }
}
